<div class="wrapper">
  <div class="main-panel">
    <app-navbar></app-navbar>
    <div class="center-content">
      <app-order-notification></app-order-notification>
      <router-outlet></router-outlet>
    </div>
  </div>
  <div class="life-sidebar">
    <app-sidebar></app-sidebar>
  </div>
</div>
